// extracted by mini-css-extract-plugin
export default {"container":"premium-list_container__ulQzv","premiumList":"premium-list_premiumList__dzGNn","notice":"premium-list_notice__torA0"};